import _complement from "ramda/src/complement";
import _equals from "ramda/src/equals";
import _toString from "ramda/src/toString";
import _pipe from "ramda/src/pipe";
import _isNil from "ramda/src/isNil";
import _anyPass from "ramda/src/anyPass";
import _test from "ramda/src/test";
import _pickBy from "ramda/src/pickBy";
import React from 'react';
export var assert = function assert(expression, errorMessage, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (!expression) {
      if (options && options.level === 'warn') {
        console.warn(errorMessage);
      } else {
        throw new Error(errorMessage);
      }
    }
  }

  return true;
};
export var deprecate = function deprecate(message) {
  return function (target) {
    if (process.env.NODE_ENV !== 'production') {
      return typeof Proxy === 'undefined' ? target : new Proxy(target, {
        get: function get(getTarget, getProp) {
          console.warn("Deprecated: ".concat(message));
          return getTarget[getProp];
        },
        apply: function apply(applyTarget, thisArg, argumentsList) {
          return applyTarget.apply(thisArg, argumentsList);
        }
      });
    }

    return target;
  };
};
export var isUndefined = function isUndefined(x) {
  return typeof x === 'undefined';
};
export var isElement = function isElement(x) {
  return React.isValidElement(x);
};
export var isNumber = function isNumber(x) {
  return typeof x === 'number';
};
export var isString = function isString(x) {
  return typeof x === 'string';
};
export var isBoolean = function isBoolean(x) {
  return typeof x === 'boolean';
};
export var isFunction = function isFunction(x) {
  return typeof x === 'function';
};
export var isHTMLElement = function isHTMLElement(x) {
  return x instanceof HTMLElement;
};
export var pickAriaAttributes = _pickBy(function (_, key) {
  return _test(/^aria-/, key);
});

var convertToDate = function convertToDate(value) {
  return new Date(value);
};

var isInvalid = _anyPass([_isNil, _pipe(convertToDate, _toString, _equals('Invalid Date'))]);

export var isValidDateTimeNumber = _complement(isInvalid);